import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationsService {

  constructor() { }

  static passwordValidator(group: FormGroup) {
    var valid = false;
    if(group.value.password == group.value.cpassword){
      valid = true;
    }
  
    if (valid) {
      return null;
    }
   
    return {
      mismatch: true
    };
  }

  static validateBalance(group: FormGroup) {
    var valid = false;
    if(group.value.availablebal >= group.value.transferamt){
      valid = true;
    }
  
    if (valid) {
      return null;
    }
   
    return {
      lowBalance: true
    };
  }
}

